import SidebarIcon from '../assets/index'

export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-purple-700">
      <SidebarIcon iconName={"geppro_sellerBranco"} className="h10 animate-pulse"/>
    </div>
  );
}
